import moment from 'moment-timezone';
import * as LogListUtil from "@/utils/LogListUtil.js";

export function toGeoLabel(value) {
  if(value) {
    if(value >= -90 && value <= 90) {
      return String(value).replace(/(\d+)\.?(\d{2})(\d{2})(:?\d+)/, "$1°$2′$3″N")
    } else if(value >= -180 && value <= 180) {
      return String(value).replace(/(\d+)\.?(\d{2})(\d{2})(:?\d+)/, "$1°$2′$3″E")
    }
  }
  return null;
}

export function toYMD(date, defaultValue) {
  if (typeof date === "string" || date instanceof String) {
    return moment(date).format("YYYY/MM/DD");
  } else if (date != null) {
    return moment(date).format("YYYY/MM/DD");
  }
  return defaultValue;
}

export function toYMDHM(date) {
  const tz = moment.tz.guess();
  if (typeof date === "string" || date instanceof String) {
    const d = new Date(date.replace("UTC", "Z"));
    return moment(d)
      .tz(tz)
      .format("YYYY/MM/DD HH:mm");
  } else if (date != null) {
    return moment(date)
      .tz(tz)
      .format("YYYY/MM/DD HH:mm");
  }
  return "";
}

export function toYMDHMZ(date) {
  const tz = moment.tz.guess();
  if (typeof date === "string" || date instanceof String) {
    const d = new Date(date.replace("UTC", "Z"));
    if (isNaN(d)) return "";
    return moment(d)
      .tz(tz)
      .format("YYYY/MM/DD HH:mm(z)");
  } else if (date != null) {
    return moment(date)
      .tz(tz)
      .format("YYYY/MM/DD HH:mm(z)");
  }
  return "";
}

export function toYMDHMSZ(date) {
  const tz = moment.tz.guess();
  if (typeof date === "string" || date instanceof String) {
    const d = new Date(date.replace("UTC", "Z"));
    if (isNaN(d)) return "";
    return moment(d)
      .tz(tz)
      .format("YYYY-MM-DDTHH:mm:ss.SSS(z)");
  } else if (date != null) {
    return moment(date)
      .tz(tz)
      .format("YYYY-MM-DDTHH:mm:ss.SSS(z)");
  }
  return "";
}

export function toDistanceFormat(totalDistance) {
  return LogListUtil.toDistanceFormat(totalDistance);
}

export function toHourFormat(seconds) {
  return LogListUtil.toHourFormat(seconds);
}

export function truncate(value, length, omission) {
  let maxLength = length ? parseInt(length, 10) : 20;
  let suffix = omission ? omission.toString() : '...';

  if (value.length <= maxLength) {
    return value;
  }

  return value.substring(0, length) + suffix;
}
